<template>
<div class='card'>
    <div class='card-header'>
        <label class='az-content-label' style='text-transform: none'>
            Pension Limits
            <small> - Current Financial Year Drawdowns</small>
        </label>
    </div>
    <div class='card-body tx-13' v-loading='loading'>
        <div class="table-responsive" v-if='pensions.length != 0'>
            <table class="table mg-b-0">
                <thead>
                <tr>
                    <th></th>
                    <th>Account</th>
                    <th>Drawdowns to date</th>
                    <th class='required-min-header'>
                        <DisclaimerV2 class='required-min-header__disclaimer'>
                          <div style="font-size:12px;max-width:600px">
                            The minimum pension amounts displayed are estimates if the most recent 30 June tax return has not been lodged. Final figures should be verified once year-end accounts are finalised.
                          </div>
                        </DisclaimerV2>
                        <div class='required-min-header__label'>Required to reach minimum</div>
                    </th>
                    <th>Minimum</th>
                    <th>Maximum</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(pension,index) in pensions" :key='pension.id'>
                    <td><i class="el-icon-user-solid"></i> {{isSample?'Mr Mike Sample '+(index+1):pension.trustee}}</td>
                    <td>{{isSample?'Sample Pension '+(index+1):pension.account}}</td>
                    <td>{{currentformats.AUformat(pension.paid)}}</td>
                    <td>{{pension.min>pension.paid?currentformats.AUformat(pension.min-pension.paid):'$0.00'}}</td>
                    <td>{{currentformats.AUformat(pension.min)}}</td>
                    <td>{{currentformats.AUformat(pension.max)}}</td>
                </tr>
                <tr>
                    <td><strong>Total</strong></td>
                    <td></td>
                    <td>{{currentformats.AUformat(totals.paid)}}</td>
                    <td>{{totals.min>totals.paid?currentformats.AUformat(totals.min-totals.paid):'$0.00'}}</td>
                    <td>{{currentformats.AUformat(totals.min)}}</td>
                    <td>{{currentformats.AUformat(totals.max)}}</td>
                </tr>
                </tbody>
            </table>
        </div><!-- table-responsive -->
        <div v-else>
            <p class='tx-13 tx-gray-700'>There are no pension accounts for this Fund.</p>
        </div>
    </div>
</div>
</template>
<script>
import currentformats from '../../../utils/currentformats'
export default {
    name:'fundpension',
    components: { 
        DisclaimerV2: () => import('@/views/adviserpanel/elements/DisclaimerV2.vue'),
    },
    data(){
        return{
            isSample:false,
            currentformats:currentformats,
            pensions:[], 
            totals:{},
            loading:true
        }
    },
    created(){
        this.getPension();
    },
    methods:{
        getPension: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample = userdetail['sample'];
            this.$api.funddashboard_api.fundPension(this.$route.params.fund_code).then(response =>{
                //note that the data for prev year and this year is reversed
                this.pensions = response.data['pension_list']
                this.totals = response.data['totals']
                this.loading=false
            });
        
        },
    }
}
</script>